import React from 'react';
import { useNavigate } from 'react-router';
import { Signpost } from '@phosphor-icons/react';

import { Stack } from 'src/components/themed/Stack';
import { EmptyState } from 'src/components/EmptyState';
import { DocumentHead } from 'src/components/DocumentHead';

/** The catch-all route: an address the storefront has nothing at (SF-A2). */
export const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="container">
      <DocumentHead title="Page not found" />
      <Stack width="100%" p={4} pb={30} maxWidth="750px">
        <EmptyState
          titleAs="h1"
          icon={<Signpost size={48} />}
          title="Page not found"
          description="There is nothing at this address. It may have moved, or the link has a typo."
          action={{ label: 'Back to cars', onClick: () => navigate('/', { replace: true }) }}
        />
      </Stack>
    </div>
  );
};
